import { Sender } from 'xstate';

import asyncCallback from '../../../framework/logic/utils/asyncCallback';
import { LogicContext } from '../types';

import config from '../../../config';

export const watchRecentlyPlayedTimer = (context: LogicContext) =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'RECENTLY_PLAYED_TO_UPDATE';
      }>
    ) => {
      let timeoutToken: ReturnType<typeof setTimeout>;
      timeoutToken = setTimeout(() => {
        callback({
          type: 'RECENTLY_PLAYED_TO_UPDATE',
        });
      }, config.intervals.recentlyPlayedGamesCheck);

      return () => {
        clearTimeout(timeoutToken);
      };
    }
  );
